var ra_key;
var ra_params;

(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;

    s.load(function () {
        'use strict'

        var trackerCode = 'retargeting';
        var TrackingScriptName = 'Retargeting';
        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker(trackerCode, TrackingModel);
        var _cartAddResponses = [];
        var _currentCartModel;

        if (!Tracker)
            return;

        var _retargetingTrackerApiKey = Tracker.Properties.RetargetingTrackerApiKey;

        if (!_retargetingTrackerApiKey) {
            return;
        }

        var cookieType = Tracker.CookieGroupCode ? Tracker.CookieGroupCode : '';
        var CanTrack = LhApp.Function.Tracking.canTrack(cookieType);

        InitAll();
        function InitAll() {
            if (!CanTrack) return;

            Init();
            // Init Retargeting.biz
            function Init(CanTrack) {
                (function () {
                    ra_key = _retargetingTrackerApiKey;
                    ra_params = {};
                    var ra = document.createElement("script");
                    ra.async = true;
                    ra.src = "https://tracking.retargeting.biz/v3/rajs/" + ra_key + ".js";

                    var s = document.getElementsByTagName("script")[0];
                    s.parentNode.insertBefore(ra, s);

                    ra.onload = initEvents;
                })();
            }

            // Init events
            function initEvents() {
                // TRACK: Brand page
                if (TrackingModel.IsBrandPage) {
                    sendBrand();
                }

                // TRACK: Category page
                if (TrackingData.IsProductListPage) {
                    sendCategory();
                }

                // TRACK: Product detail
                if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductListsData) {
                    sendProduct();
                }

                // TRACK: Checkout page
                if (TrackingData.IsCheckoutPage) {
                    checkoutIds();
                }

                // TRACK order completion
                if (TrackingModel.IsThankYouPage) {
                    saveOrder(); // ToDo
                }

                // TRACK Help page
                if (isHelpPage()) {
                    visitHelpPage();
                }

                // IMPORTANT execute this scripts in all other pages except checout
                if (typeof (Vendd) != "undefined" && Vendd.Scripts) {
                    //HELPER this script keep track of products added to cart
                    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {
                        var res = envelope.message.data;

                        _cartAddResponses.push({
                            ProductId: res.id,
                            SkuId: res.skuId,
                            Quantity: parseFloat(res.qty)
                        });

                    });

                    //TRACK add to cart (recorded by the ABOVE script)
                    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                        //keep variable of cart items model synced to rela data in order to use it during item deletion
                        _currentCartModel = JSON.parse(JSON.stringify(envelope.message.data.Cart));//clone

                        var cartModel = envelope.message.data.Cart;
                        var pAddResponse = _cartAddResponses.shift();

                        (function AddToCartTrack(p) {
                            if (!p) {
                                return;
                            }

                            var pCartItemModel = cartModel.Items.filter(function (i) {
                                return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                            })[0];

                            if (pCartItemModel) {
                                addToCart(pCartItemModel, pAddResponse);
                            }

                            AddToCartTrack(_cartAddResponses.shift());

                        })(pAddResponse);
                    });


                    // Remove from Cart
                    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, TrackingScriptName, function (envelope) {
                        if (!_currentCartModel) {
                            return;
                        }

                        var pCartItemModel = _currentCartModel.Items.filter(function (i) {
                            return i.Id == envelope.message.data.id;
                        })[0];

                        if (!pCartItemModel) {
                            return;
                        }

                        removeFromCart(pCartItemModel);
                    });



                    // Add To Wishlist
                    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.AddSuccess, TrackingScriptName, function (envelope) {
                        var res = envelope.message.data;

                        addToWishlist(res.productId);
                    });

                    // TRACK: User registration
                    Vendd.MessageBus.subscribe(Vendd.User.Messages.Register, TrackingScriptName, function (envelope) {
                        var res = envelope.message.data;

                        setEmail(res, true);
                    });

                    // TRACK: Login
                    Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, TrackingScriptName, function (envelope) {
                        var res = envelope.message.data;

                        setEmail({ email: res.loginName });
                    });

                    // TRACK: Subscribe
                    Vendd.MessageBus.subscribe(Vendd.Newsletter.Messages.SubscribeSuccess, TrackingScriptName, function (envelope) {
                        var res = envelope.message.data;

                        subscribeEmailInfo(res.email);
                    });
                }

                // TRACK: Main product image click
                addEventToMainProductImage();
            }

            function addEventToMainProductImage() {
                var mainProductImg = document.querySelector('.first.gallery-item img');

                if (mainProductImg) {
                    mainProductImg.addEventListener('click', clickImage);
                }
            }

            function setRetargetingInfo(param, paramName) {
                var ra = _ra || {};

                if (ra.ready !== undefined) {
                    ra[paramName] = param;
                }
            }

            function sendEvent(methodName, paramsArray) {
                var ra = _ra || {};

                if (ra.ready !== undefined) {
                    ra[methodName](...paramsArray);
                }
            }

            // TRACK: User registers or logs in
            function setEmail(data, isRegister) {
                var setEmailInfo = {
                    email: data.email
                };

                if (isRegister) {
                    setEmailInfo.name = `${data.firstName} ${data.lastName}`;
                    setEmailInfo.phone = data.mobilephone;
                }

                console.log('setEmailInfo: ', setEmailInfo, isRegister);

                sendEvent('setEmail', [setEmailInfo]);
            }

            // TRACK: User subscribes
            function subscribeEmailInfo(email) {
                var subscribeEmailInfo = {
                    "email": email,
                    "status": true
                };

                console.log('subscribeEmailInfo: ', subscribeEmailInfo);

                setRetargetingInfo('subscribeEmailInfo', subscribeEmailInfo);
                sendEvent('subscribeEmail', [subscribeEmailInfo]);
            }

            // TRACK: Brand page visiting
            function sendBrand() {
                var sendBrandInfo = {
                    id: TrackingModel.BrandId,
                    name: TrackingModel.BrandName
                };

                console.log('sendBrandInfo: ', sendBrandInfo);

                setRetargetingInfo('sendBrandInfo: ', sendBrandInfo);
                sendEvent('sendBrand', [sendBrandInfo]);
            }

            // TRACK: Category page visiting
            function sendCategory() {
                var breadcrumb = getBreadcrumb([TrackingModel.CategoryId]);

                var sendCategoryInfo = {
                    id: TrackingModel.CategoryId,
                    name: TrackingModel.CategoryName,
                    url: document.location.href,
                    parent: breadcrumb.length ? breadcrumb[0].id : false,
                    breadcrumb: breadcrumb
                };

                console.log('sendCategoryInfo: ', sendCategoryInfo);

                setRetargetingInfo('sendCategoryInfo', sendCategoryInfo);
                sendEvent('sendCategory', [sendCategoryInfo]);
            }

            // TRACK: Adding to cart
            function addToCart(pCartItemModel, pAddResponse) {
                var addToCartInfo = {
                    product_id: pAddResponse.ProductId,
                    quantity: pAddResponse.Quantity,
                    variation: getVariations(pCartItemModel)
                };

                console.log('addToCartInfo: ', addToCartInfo);

                setRetargetingInfo('addToCartInfo', addToCartInfo);
                sendEvent(
                    'addToCart',
                    [addToCartInfo.product_id, addToCartInfo.product_id, addToCartInfo.variation]
                );
            }

            // TRACK: Adding to wishlist
            function addToWishlist(product_id) {
                console.log('addToWishlist: ', { product_id });

                setRetargetingInfo('addToWishlistInfo', { product_id });
                sendEvent('addToWishlist', [product_id]);
            }

            function checkoutIds() {
                var ids = getCheckoutIds(TrackingModel.CartProductsData);

                console.log('checkoutIds ids: ', ids);

                setRetargetingInfo('checkoutIdsInfo', ids);
                sendEvent('checkoutIds', [ids]);
            }

            function clickImage() {
                var product_id = TrackingModel.ProductData[0].ProductId;

                console.log('clickImage id: ', { product_id });

                setRetargetingInfo('clickImageInfo', { product_id });
                sendEvent('clickImage', [product_id]);
            }

            function removeFromCart(pCartItemModel) {
                var removeFromCartInfo = {
                    product_id: pCartItemModel.ProductId,
                    quantity: pCartItemModel.Quantity,
                    variation: getVariations(pCartItemModel)
                };

                console.log('removeFromCartInfo: ', removeFromCartInfo);

                setRetargetingInfo('removeFromCartInfo: ', removeFromCartInfo);
                sendEvent(
                    'removeFromCart',
                    [removeFromCartInfo.product_id,
                    removeFromCartInfo.quantity,
                    removeFromCartInfo.variation]
                );
            }

            function saveOrder() {
                var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                oScope.Model.Data.Profile

                var modelData = oScope.Model.Data;

                var discounts = {
                    codes: [],
                    amount: 0
                };

                for (var i = 0; i < TrackingModel.Order.Discounts.Order.length; i++) {
                    var discount = TrackingModel.Order.Discounts.Order[i];

                    if (discount.AmountN) {
                        discounts.codes.push(discount.Coupon);
                        discounts.amount += discount.AmountN;
                    }
                }

                var saveOrderInfo = {
                    order_no: TrackingModel.Order.Code,
                    lastname: modelData.Profile.LastName,
                    firstname: modelData.Profile.FirstName,
                    email: TrackingModel.Order.CustomerEmail,
                    phone: TrackingModel.Order.CustomerMobiles,
                    state: modelData.Billing.Area,
                    city: modelData.Billing.City,
                    address: modelData.Billing.Address,
                    discount_code: discounts.codes.join('|'),
                    discount: discounts.amount,
                    shipping: TrackingModel.Order.ShippingCostN,
                    rebates: 0,
                    fees: 0,
                    total: TrackingModel.Order.TotalPriceN
                };

                var saveOrderProducts = [];

                for (var i = 0; i < TrackingModel.CartProductsData.length; i++) {
                    var product = TrackingModel.CartProductsData[i];

                    saveOrderProducts.push({
                        id: product.ProductId,
                        quantity: product.Quantity,
                        price: product.PriceN,
                        variation_code: product.Color ? `${product.Color}-${product.Size}` : ""
                    });
                }

                console.log('saveOrderInfo: ', saveOrderInfo);
                console.log('saveOrderProducts: ', saveOrderProducts);

                setRetargetingInfo('saveOrderInfo: ', saveOrderInfo);
                setRetargetingInfo('saveOrderProducts: ', saveOrderProducts);
                sendEvent(
                    'saveOrder',
                    [saveOrderInfo, saveOrderProducts]
                );
            }

            function sendProduct() {
                var breadcrumb = getBreadcrumb([TrackingModel.CategoryId, TrackingModel.ProductData[0].ProductId]);

                var sendProductInfo = {
                    id: TrackingModel.ProductData[0].ProductId,
                    name: TrackingModel.ProductData[0].Name,
                    url: document.location.href,
                    img: TrackingModel.ProductData[0].Image,
                    price: TrackingModel.ProductData[0].DeletedPriceN ? TrackingModel.ProductData[0].DeletedPriceN : TrackingModel.ProductData[0].PriceN,
                    promo: TrackingModel.ProductData[0].DeletedPriceN ? TrackingModel.ProductData[0].PriceN : 0,
                    stock: 1,
                    brand: {
                        id: TrackingModel.ProductData[0].BrandId,
                        name: TrackingModel.ProductData[0].Brand
                    },
                    category: [{
                        id: TrackingModel.CategoryId,
                        name: TrackingModel.CategoryName,
                        parent: breadcrumb[0].id || false,
                        breadcrumb: breadcrumb
                    }],
                    inventory: getInventory(TrackingModel.ProductData[0].Colors, TrackingModel.ProductData[0].Sizes)
                };

                console.log('sendProductInfo: ', sendProductInfo);

                setRetargetingInfo('sendProductInfo: ', sendProductInfo);
                sendEvent('sendProduct', [sendProductInfo]);
            }

            function visitHelpPage() {
                var visitHelpPageInfo = {
                    "visit": true
                }

                console.log('visitHelpPageInfo: ', visitHelpPageInfo);

                setRetargetingInfo('visitHelpPageInfo: ', visitHelpPageInfo);
                sendEvent('visitHelpPage', visitHelpPageInfo);
            }
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                CanTrack = LhApp.Function.Tracking.canTrack(cookieType);
                InitAll();
            });
        }
    });

    // Helpers
    function getVariations(pCartItemModel) {
        if (pCartItemModel.Dimensions.length === 0) {
            return false;
        }

        var variation = {
            code: `${pCartItemModel.Dimensions[0].Name}-${pCartItemModel.Dimensions[1].Size}`,
            stock: 1,
            details: getDetails(pCartItemModel.Dimensions)
        }

        return variation;
    }

    function getDetails(dimensions) {
        if (dimensions.length === 0) {
            return false;
        }

        var details = {};

        for (let i = 0; i < dimensions.length; i++) {
            var dimension = dimensions[i];
            details[dimension.Name] = {
                category_name: dimension.Color ? "Color" : "Size",
                category: dimension.Code,
                value: dimension.Color ? dimension.Name : dimension.Size
            }
        }

        return details;
    }

    function getCheckoutIds(cartProductsData) {
        var ids = [];

        for (var i = 0; i < cartProductsData.length; i++) {
            ids.push(cartProductsData[i].ProductId);
        }

        return ids;
    }

    function getBreadcrumb(excludeIds) {
        var breadcrumb = [];
        var fullPathIdsString = LhApp.Context.Item.FullPath;
        var fullPathNames = TrackingData.Path;

        if (fullPathIdsString[0] === ',') {
            fullPathIdsString = fullPathIdsString.slice(1);
        }

        if (fullPathIdsString[fullPathIdsString.length - 1] === ',') {
            fullPathIdsString = fullPathIdsString.slice(0, fullPathIdsString.length - 1);
        }

        var fullPathIds = fullPathIdsString.split(',');
        fullPathIds = fullPathIds.slice(fullPathIds.length - fullPathNames.length);

        for (var i = fullPathNames.length - 1; i >= 0; i--) {
            if (!(excludeIds && excludeIds.includes(fullPathIds[i]))) {
                breadcrumb.push({
                    id: fullPathIds[i],
                    name: fullPathNames[i],
                    parent: i === 0 ? false : fullPathIds[i - 1]
                });
            }  
        }

        return breadcrumb;
    }

    function getInventory(colors, sizes) {
        var inventory = {};

        for (var i = 0; i < colors.length; i++) {
            for (let j = 0; j < sizes.length; j++) {
                inventory[`${colors[i].Name}-${sizes[j].Name}`] = true;
            }
        }

        if (Object.keys(inventory).length === 0) {
            inventory = {
                stock: true,
                variations: false
            }
        }

        return inventory;
    }

    function isHelpPage() {
        return LhApp.Context.Item.Template.toLowerCase() === 'faq';
    }
})();